import { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import Common from "../../../helper/common";
import {
  respEnum,
} from "../../../constants/appConstant";
import { Formik } from "formik";
import { Icon } from "@iconify/react";
import {
  FormikInput,
} from "../../../components/formik-components";
import { Button } from "../../../components/ui/button";

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";

const FormikInitialValues = {
  bin: null,
  bank:null,
  scheme:null,
};

const formikValidation = yup.object({
  bin:yup.string().min(1)
        .max(9).required("Bin number is required"),
    bank: yup.string().required("Bank number is required"),
});

const AddBinNumber = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  
  useEffect(() => {
    const fetchData = async () => {
    };
    fetchData();
  }, []);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);


  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };
    
    data.bank = data.bank;
    data.scheme=data.scheme?? null;
    data.bin=parseInt(data.bin,10);

    let response = await Common.ApiService.getInstance().request(
      "AddUpdateBinNumber",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/bins", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetBinNumber?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {

      const item = response.data[0];

      formikRef.current.setValues({...item});
    }
  };
  
  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Bin Number
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2 max-h-[450px] overflow-y-auto pr-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                    
                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"bin"}
                          label={"Bin"}
                          placeholder={"Enter Bin Number"}
                        />
                      </div>

                      <div className="flex flex-col gap-1">
                        <FormikInput
                          formikProps={formikProps}
                          name={"bank"}
                          label={"Bank"}
                          placeholder={"Enter Bank Name"}
                          maxLength="50"
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"scheme"}
                          label={"Scheme"}
                          placeholder={"Scheme"}
                          maxLength="50"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddBinNumber;
